import { QueryClientProvider } from '@tanstack/react-query';
import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './locales/i18n';
import './global.css';
import './theme/theme.css';
import App from './App';
import { registerLocalIcons } from './components/icon';
import { RouteLoadingProgress } from './components/loading';
import { queryClient } from './api/queryClient';

const charAt = `
  ╔═══════ FDTV+ Admin ═══════╗
  ║                           ║
  ║  Modern React Admin UI    ║
  ║  Built with React & Vite  ║
  ║                           ║
  ╚═══════════════════════════╝
`;
console.info(`%c${charAt}`, 'color: #5BE49B; font-weight: bold;');

await registerLocalIcons();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      <Suspense>
        <RouteLoadingProgress />
        <App />
      </Suspense>
    </QueryClientProvider>
  </HelmetProvider>,
);
